import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'live-class',
  templateUrl: './live-class.component.html',
  styleUrls: ['./live-class.component.css'],
  // selector: 'app-safe-iframe',
  // template: `
  //   <h2>Loading External Content</h2>
  //   <iframe [src]="safeExternalUrl" frameborder="0" width="600" height="400"></iframe>
  //   <p *ngIf="!externalUrl">Loading...</p>
  // `,
})
export class LiveClassComponent {
  externalUrl: string = 'https://meet.jit.si/ec-class-room-ec-class-room-56165sf';
  safeExternalUrl: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) {
    this.safeExternalUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.externalUrl);
  }
}
